const BaseModule = require('../../90_utils/base/BaseModule');

class FracturedGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$graphWrapper = this.$el.find('.graph-wrapper');
		this.$svg = this.$el.find('.svg-graph');
		this.$domData = this.$el.find('.dom-data');

		this.centerTemplate = _.template(this.$el.find('#center-template').html());
		this.graphTemplate = _.template(this.$el.find('#graph-template').html());
		this.sectorLabelTemplate = _.template(this.$el.find('#sector-label-template').html());

		this.$el.find('#graph-template').remove();
		this.$el.find('#sector-label-template').remove();

		this.isFirstBuild = true;
		this.shouldAnimate = false;
	}

	// basemodule methods

	_domReady(){

		this.$domData = this.$el.find('.dom-data');

		if(this.$domData.length){
			this._retrieveDomData();
			this._rebuild();
		}
	}

	_addListeners(){

	}

	_removeListeners(){

	}

	//

	_show(){
		this.shouldAnimate = true;
		this._animateBars();
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	// public swap data / rebuild method

	swapData(graphData){
		this.graphData = graphData;
		this.shouldAnimate = true;
		this._rebuild();
		this._animateBars();
	}

	//

	_animateBars(){

		if( this.shouldAnimate && !window.utils.BrowserUtils.isIE() ){

			let $bars = this.$el.find('.svg-graph #inner-circles circle');

			$bars.each((i, el)=>{

				let $el = $(el);
				let dasharray = $el.css('stroke-dasharray');

				if( dasharray ){
					let strokeoffset = dasharray.split(',');
					let offset1 = parseFloat(strokeoffset[ 0 ]);
					let offset2 = parseFloat(strokeoffset[ 1 ]);

					let offset = { length: 0 };

					TweenMax.set($el, { 'stroke-dasharray': offset.length + ' ' + offset2 });
					TweenMax.to(offset, 0.6, {
						length: offset1,
						ease: 'progressSlide',
						delay: (i*0.1),
						onUpdate: ()=>{
							TweenMax.set($el, { 'stroke-dasharray': offset.length + ' ' + offset2 });
						}
					});
				}
			});

			this.shouldAnimate = false;
		}
	}

	_retrieveDomData(){

		this.graphData = {
			maxValue: this.$domData.attr('data-max-value')
		};

		// center

		let $centerData = this.$domData.find('.center');

		this.graphData.center = {
			value: $centerData.attr('data-value'),
			unit: $centerData.attr('data-unit'),
			supheader: $centerData.attr('data-supheader'),
			subheader: $centerData.attr('data-subheader')
		}

		// data points

		let $dataPoints = this.$domData.find('.data-point');

		this.graphData.dataPoints = [];

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.graphData.dataPoints.push({
				label: $dataPoint.attr('data-label'),
				subheader: $dataPoint.attr('data-subheader'),
				value: $dataPoint.attr('data-value')
			});
		});
	}

	_rebuild(){

		let $bgCircle = this.$el.find('#bg-circle');
		let $svgWrapper = this.$el.find('.svg-wrapper');
		let $sectorLabels = this.$el.find('.sector-labels');

		let graphViewBox = {
			width: 580,
			height: 580
		}

		let minRadius = 160;
		let lineWidth = window.SETTINGS.breakpoint.minWidth('screen-phablet') ? 10 : 16;
		let labelDistance = 32;
		let maxLabelDistance = window.utils.BrowserUtils.isIE() ? 30 : 60;

		let totalPoints = this.graphData.dataPoints.length;
		let maxRadius = minRadius + totalPoints * lineWidth;

		let circleCompleteRatio = 0;

		// resize bg circle

		let bg = {
			strokeWidth: totalPoints * lineWidth,
			r: minRadius - lineWidth/2 + totalPoints * lineWidth / 2,
			cx: graphViewBox.width/2,
			cy: graphViewBox.height/2
		};

		// rebuild inner circles

		let innerCircles = [];
		let sectorLabels = [];

		for(let i=0; i<totalPoints; i++){

			// divide into sectors

			let dataPoint = this.graphData.dataPoints[i];
			let radius = lineWidth * (totalPoints - i - 1) + minRadius;
			let ratio = dataPoint.value / this.graphData.maxValue;
			let circumference = radius * 2 * Math.PI;
			let dashArray = `${circumference * ratio} ${circumference}`;
			let dashOffset = 0 - circumference * circleCompleteRatio;
			let lineStyle = `stroke-dasharray: ${dashArray}; stroke-dashoffset: ${dashOffset};`;
			let rotation = (-90) + 360 * circleCompleteRatio;

			innerCircles.push({
				id: 'inner-circle' + i,
				lineWidth: lineWidth,
				style: lineStyle,
				r: radius,
				cx: graphViewBox.width/2,
				cy: graphViewBox.height/2,
				transform: `rotate(-90 ${graphViewBox.width/2} ${graphViewBox.height/2})`
			});

			// position labels

			let graphBounds = window.utils.PositioningUtils.getExtendedOffset($svgWrapper);
			let svgOffset = $svgWrapper.position()
			let resizeRatio = graphBounds.width / graphViewBox.width;

			if(resizeRatio < 1){
				// resizeRatio *= 1.2;
				labelDistance /= (1 - resizeRatio) * 0.6;
			} // scale distance up slightly as graph gets smaller

			labelDistance = Math.min(labelDistance, maxLabelDistance);

			let rad = (circleCompleteRatio + ratio/2 - 0.25) * 2 * Math.PI;
			let labelX = Math.cos(rad) * (maxRadius + labelDistance) * resizeRatio + graphBounds.width/2 + svgOffset.left;
			let labelY = Math.sin(rad) * (maxRadius + labelDistance) * resizeRatio + graphBounds.height/2 + svgOffset.top;

			let xModifier = Math.min(0, Math.cos(rad)) * (dataPoint.label.length * 4);

			// console.log('graph bounds', graphBounds.width, 'viewbox', graphViewBox.width, 'rad', rad, 'maxRadius', maxRadius, 'labelDistance', labelDistance, 'resizeRatio', resizeRatio, 'coords:', labelX, labelY, dataPoint.label, dataPoint.subheader);

			sectorLabels.push({
				top: labelY,
				left: labelX + xModifier,
				label: dataPoint.label,
				subheader: dataPoint.subheader
			});

			circleCompleteRatio += ratio;
		}

		// console.log('---');

		// center area

		let $graphCenter = this.$el.find('.graph-center');
		let centerData = this.graphData.center;

		let center = {
			supheader: centerData.supheader,
			subheader: centerData.subheader,
			unit: centerData.unit,
			title: window.utils.NumberUtils.addCommas(centerData.value)
		};

		if(!center.title){
			this.$el.addClass('empty-center');
		}
		else {
			this.$el.removeClass('empty-center');
		}

		//

		$graphCenter.html(this.centerTemplate(center));

		$svgWrapper.html(this.graphTemplate({
			bg: bg,
			innerCircles: innerCircles
		}));

		$sectorLabels.html(this.sectorLabelTemplate({
			sectorLabels: sectorLabels
		}));

		// 'refresh' svg (won't display otherwise)

		this.$graphWrapper.html(this.$graphWrapper.html())
	}

	//

	_domUpdate(){

	}

	_resize(){
		if(this.graphData){
			this._rebuild();
		}
	}

}

module.exports = FracturedGraph;
